<template>
  <transition name="fade-scale">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4"
      @click="handleClose"
    >
      <div
        class="bg-white rounded-2xl p-6 max-w-lg w-full animate-scale-in"
        @click.stop
      >
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
              <IconLightbulb class="w-4 h-4 text-amber-500" />
            </div>
            <h3 class="text-lg font-bold text-slate-900">我也来支招</h3>
          </div>
          <button
            @click="handleClose"
            class="p-2 hover:bg-slate-100 rounded-full transition-colors"
          >
            <IconX class="w-5 h-5 text-slate-400" />
          </button>
        </div>

        <!-- Topic Info -->
        <div class="bg-slate-50 rounded-xl p-3 mb-4">
          <p class="text-xs text-slate-500 mb-1">当前话题</p>
          <p class="text-sm font-medium text-slate-900">{{ topicTitle }}</p>
        </div>

        <p class="text-sm text-slate-500 mb-4">
          分享您的实战经验或独到见解，帮助更多管理者解决类似问题。
        </p>

        <!-- Content Input -->
        <div class="mb-4">
          <textarea
            v-model="content"
            placeholder="分享您的经验或建议..."
            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm resize-none focus:outline-none focus:border-amber-400 transition-colors"
            rows="6"
            maxlength="1000"
          />
          <div class="flex justify-between text-xs text-slate-400 mt-2">
            <span>建议包含：背景、做法、成效</span>
            <span>{{ content.length }}/1000</span>
          </div>
        </div>

        <!-- Tips -->
        <div class="bg-amber-50 rounded-xl p-3 mb-6">
          <p class="text-xs text-amber-700">
            优质内容将被展示在案例库中，并获得积分奖励
          </p>
        </div>

        <!-- Actions -->
        <div class="flex gap-3">
          <button
            @click="handleClose"
            class="flex-1 px-4 py-2.5 border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors text-sm font-medium"
          >
            取消
          </button>
          <button
            @click="handleSubmit"
            :disabled="!content.trim()"
            class="flex-1 px-4 py-2.5 bg-amber-400 text-white rounded-xl hover:bg-amber-500 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            <IconSend class="w-4 h-4" />
            提交分享
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { IconLightbulb, IconX, IconSend } from '../icons'

export default {
  name: 'ContributeModal',
  components: {
    IconLightbulb,
    IconX,
    IconSend
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    topicTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: ''
    }
  },
  methods: {
    handleSubmit() {
      if (!this.content.trim()) return

      // 保存到 store
      const contribution = {
        id: `contrib-${Date.now()}`,
        type: 'suggestion',
        title: this.topicTitle || '话题建议',
        content: this.content.trim(),
        status: 'pending',
        submittedAt: Date.now(),
        contributorId: 'current-user',
        contributorName: '管理者',
        likes: 0,
        points: 0,
      }

      this.$store.commit('SET_CONTRIBUTIONS', [contribution, ...this.$store.state.contributions])

      this.$emit('submit', this.content.trim())
      this.reset()
      this.$emit('close')
    },
    handleClose() {
      this.reset()
      this.$emit('close')
    },
    reset() {
      this.content = ''
    }
  }
}
</script>
